// extracted by mini-css-extract-plugin
export var logo = "_93-2";
export var logoWrapper = "_93-1";
export var strip = "_93-0";